/* eslint-disable import/first */
import React from 'react';
import { useNavigate, useLocation } from '@reach/router';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { FormattedMessage, useIntl } from 'react-intl';
const { selectDesktop } = Slices.appSlice;
import Button from '@material-ui/core/Button';

import css from './index.module.scss';

const CustomizedBox = ({ reset, route, customizeDescription, resetButton }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const intl = useIntl();
  const isDesktop = useSelector(selectDesktop);
  const handleRoute = (e) => {
    e.preventDefault();
    if (!reset) {
      navigate(route, {
        state: {
          oldLocation: location,
          description: intl.formatMessage({ id: 'customize_your_meals' }),
        },
      });
    }
  };

  return (
    <div className={css.customizedBox}>
      <div className={css.customizedBtnWrapper}>
        {reset && (
          <h4 className={css.wordText}>
            <FormattedMessage id="CUSTOMIZED" defaultMessage="CUSTOMIZED" />
          </h4>
        )}
        {reset && (
          <Button variant="outlined" size="small" className={css.resetBtn} onClick={resetButton}>
            {intl.formatMessage({ id: 'customize_reset' })}
          </Button>
        )}
      </div>
      {/* <p>
        {productObj.description < 100
          ? productObj.description
          : productObj.description.substring(0, 100) + '...'}
      </p> */}
      <p onClick={handleRoute}>
        {!reset && (
          <em>
            <FormattedMessage id="CUSTOMIZED" defaultMessage="CUSTOMIZED" /> :
          </em>
        )}
        {/* Commenting out the ellipsis for now till we figure out a more reliable method */}
        {isDesktop &&
          (customizeDescription?.length < 70
            ? customizeDescription
            : customizeDescription?.substring(0, 70) + '...')}
        {!isDesktop && customizeDescription}
        {!isDesktop && !reset && (
          <span>
            <FormattedMessage id="customizeEdit" defaultMessage="Edit" />
          </span>
        )}
      </p>
      {/* TODO: change it during customization page <h5>Add-ons -></h5> */}
    </div>
  );
};

export default CustomizedBox;
